import { MemberProfileKey } from '@shared/local-storage.key';

export function getMemberAccountId(): number | null {
  for (const key of [MemberProfileKey, 'user_data']) {
    const raw = localStorage.getItem(key);
    if (!raw) continue;

    try {
      const id = JSON.parse(raw)?.id;
      if (id) return id;
    } catch {
    }
  }

  return null;
}
